<template>
  <div id="app">
      <MainComponent></MainComponent>
  </div>
</template>

<script>
  import MainComponent from "@/components/MainComponent.vue";

  export default {
    components: {
      MainComponent
    }
  }
</script>

<style>
@font-face {
  font-family: "TT Chocolates";
  src: url("./assets/fonts/TT Chocolates Trial Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
}

* {
  font-family: "TT Chocolates", sans-serif;
}

html, body {
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;
}
</style>

